
<div
  class="panel rs-wd-s16 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
></div>
<div
  class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-skeleton rs-anim-loading hide-for-medium-up"
></div>
<div
  class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
></div>
<div class="row">
  <div class="columns small-12 medium-4">
    <div
      class="panel rs-maxw rs-h-s4 rs-h-m5 rs-no-padding rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
    ></div>
  </div>
</div>
<div class="rs-me"></div>
